<template>
  <div class="pay-documents tile">
    <div class="tile__header mb--4" :style="'background: #3d7bf2'">
      <h3>Pay Documents</h3>
      <img class="tile__header__image" :src="require('../assets/icons/paydocument.svg')" />
    </div>
    <div class="container text--center">
      <p v-if="documents.length && documentsData.length">Click on the document to view it.</p>
      <p v-else>There are no documents to display</p>
      <ui-loading :loading="loading" />
      <div class="payslips__table">
        <table v-if="documents.length && documentsData.length" class="mdl-data-table mdl-js-data-table m--auto w--100">
          <thead>
            <tr>
              <th>Name</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(document, key) in documentsData"
              :key="key"
              @click="openDocument(document.document_url)"
            >
              <td v-text="getDocumentName(document.document_type)"></td>
              <td v-text="document.created_at"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import UiLoading from '../components/UILoading'
import { getPayDocuments } from 'ewage-portal-files'
const documentTypes = require('core-document-types').documentTypes

export default {
  name: 'pay-documents',
  components: { UiLoading },
  data: () => ({
    loading: false,
    documents: [],
    documentsData: [],
    errorMessage: null,
  }),
  methods: {
    getDocumentName (id) {
      let docsTypes = documentTypes.getDocumentTypes()
      return (docsTypes.find(doc => doc.typeId === id)) ? docsTypes.find(doc => doc.typeId === id).name : id
    },
    openDocument (url) {
      if (this.$matomo) {
        this.$matomo.trackEvent('Pay Documents', 'Pay Document', 'Pay Document Table')
      }

      window.open(url)
    }
  },
  async mounted () {
    this.loading = true
    let { documents, records, error } = await getPayDocuments(this.$store.getters.user.client_id, this.$store.getters.user.id)
    this.documents = documents
    this.documentsData = records
    this.errorMessage = error
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
table {
  min-width: 300px;

  tbody {
    tr {
      cursor: pointer;
    }
  }
}
</style>
